import { render, staticRenderFns } from "./my-course.vue?vue&type=template&id=177bfa50&scoped=true&"
import script from "./my-course.vue?vue&type=script&lang=js&"
export * from "./my-course.vue?vue&type=script&lang=js&"
import style0 from "./my-course.vue?vue&type=style&index=0&id=177bfa50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177bfa50",
  null
  
)

export default component.exports